/* unplugin-vue-components disabled */import script from "./NoType.vue?vue&type=script&setup=true&lang=js"
export * from "./NoType.vue?vue&type=script&setup=true&lang=js"

import "./NoType.vue?vue&type=style&index=0&id=2df0dce1&lang=scss"

const __exports__ = script;

export default __exports__